import { Component, Input } from '@angular/core';
import { Course } from '@core/models/course.model';

@Component({
  selector: 'app-single-course-block',
  templateUrl: './single-course-block.component.html',
  styleUrl: './single-course-block.component.css',
})
export class SingleCourseBlockComponent {
  @Input() course?: Course;
}
